import React, { useContext, useEffect, useState } from "react";
import { View, StyleSheet, ActivityIndicator, Image } from "react-native";
import { SafeAreaView } from "react-navigation";
import { Text, Button } from "react-native-elements";
import ArrowIcon from "../../images/arrow_icon.png";
import CuentaIcon from "../../images/cuenta.png";

import { Context as UserAccessConext } from "../../dataStore/userAccessContext";
import { TouchableOpacity } from "react-native-gesture-handler";
import { navigate } from "../../utils/NavigationRef";

const AccountScreen = () => {
  const { onLogout } = useContext(UserAccessConext);
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [telefonoEmpresa, setTelefonoEmpresa] = useState('');

  useEffect(() => {
    // Verifica si ya existen datos en el almacenamiento local
    const savedData = JSON.parse(localStorage.getItem('userData'));
    const savedEmpresa = JSON.parse(sessionStorage.getItem('configuracion'));
    if (savedData) {
      setName(savedData.name);
      setAddress(savedData.address);
      setPhone(savedData.phone);
    }
    if (savedEmpresa.telefono) {
      setTelefonoEmpresa(savedEmpresa.telefono);
    }
  }, []);

  return (
    <SafeAreaView style={styles.contentView} forceInset={{ top: "always" }}>
      <View style={styles.titleView}>
        <View style={styles.profileView}>
          <Image
            source={CuentaIcon}
            style={styles.imageStyle}
          />
          <View style={{ marginLeft: 10 }}>
            <Text h4 style={{ color: "#383838" }}>
              {name != '' ? name : "Invitado"}
            </Text>
            <Text style={{ color: "#7B7B7B" }}>Dirección {address != '' ? address : ""}</Text>
            <Text style={{ color: "#7B7B7B" }}>Celular {phone != '' ? phone : ""}</Text>
          </View>
        </View>
      </View>
      <View style={styles.listView}>
        {/* view Orders */}
        <TouchableOpacity onPress={() => navigate("Order")}>
          <View style={styles.options}>
            <Text style={styles.optionsText}>Mis Ordenes</Text>
            <Image source={ArrowIcon} style={styles.icon} />
          </View>
        </TouchableOpacity>
        {/* Contact Us */}
        <TouchableOpacity onPress={() => {window.location = "https://wa.me/57"+telefonoEmpresa}}>
          <View style={styles.options}>
            <Text style={styles.optionsText}>Soporte</Text>
            <Image source={ArrowIcon} style={styles.icon} />
          </View>
        </TouchableOpacity>
        <View style={styles.options}>
          <Text style={styles.optionsText}>V.2024-10-27 18:30</Text>
        </View>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  contentView: {
    backgroundColor: "#F2F2F2",
    flex: 1,
    justifyContent: "space-between",
  },
  titleView: {
    flex: 2,
    justifyContent: "center",
    alignItems: "center",
    justifyContent: "space-between",
  },
  listView: {
    flex: 9,
    backgroundColor: "white",
  },
  bottomView: {
    flex: 1,
  },
  icon: {
    width: 40,
    height: 40,
  },
  imageStyle: {
    width: 100,
    height: 100,
    borderRadius: 50,
  },
  profileView: {
    margin: 10,
    padding: 10,
    flex: 1,
    width: "90%",
    flexDirection: "row",
    alignItems: "center",
  },
  options: {
    display: "flex",
    height: 80,
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    paddingLeft: 20,
    paddingRight: 20,
    borderTopColor: "#DFDFDF",
    borderTopWidth: 0.5,
    borderBottomColor: "#DFDFDF",
    borderBottomWidth: 0.5,
  },
  optionsText: {
    fontSize: 18,
  },
  signoutButton: {
    marginTop: 7,
    width: 300,
    height: 50,
    backgroundColor: "#A3A2A2",
    alignSelf: "center",
    borderRadius: 30,
  },
  titleStyle: {
    fontSize: 18,
    fontWeight: "600",
    color: "white",
    marginTop: 3,
  },
});

export default AccountScreen;
